var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMerchIcon = function SvgMerchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "menu-item-merch",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 4595"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54763"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 4588 \\u2013 5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.637 7.541a30.506 30.506 0 0 0-5.738 2.425c-.183.163-2.982 6.863-4.049 8.338-.125.2 4.815 2.06 5.732 2.422v11.97h14.863V20.729c.918-.362 5.858-2.221 5.732-2.422-1.066-1.476-3.866-8.176-4.049-8.338a30.489 30.489 0 0 0-5.735-2.428c-.734 2.784-6.023 2.782-6.756 0Z",
    fill: "none",
    "data-fill": "a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108512",
    d: "M17.125 13.001a1.114 1.114 0 0 0-1.111 1.111v5.779a1.114 1.114 0 0 0 1.111 1.11h5.779a1.114 1.114 0 0 0 1.11-1.11v-5.779a1.114 1.114 0 0 0-1.11-1.111Zm0 .445h5.779a.661.661 0 0 1 .667.667v2.575l-1.4-1.4a.223.223 0 0 0-.314 0l-2.51 2.51-1.621-1.621a.222.222 0 0 0-.314 0l-.954.954v-3.02a.661.661 0 0 1 .667-.667Z"
  }))))));
};
export default SvgMerchIcon;